import YearGroups from "./routes/YearGroups";
import SubjectView from "./routes/SubjectView";
import StudentView from "./routes/StudentView";
import StudentDetails from "./routes/StudentDetails";

const ECoursework = [YearGroups, SubjectView, StudentView, StudentDetails];

export { ECoursework };
